module.exports = __webpack_public_path__ + "img/01-full.4349b33b.jpeg";